import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';

@Component({
  selector: 'app-ExpertCalibrationAdd',
  templateUrl: './ExpertCalibrationAdd.component.html',
  styleUrls: ['./ExpertCalibrationAdd.component.scss']
})
export class ExpertCalibrationAddComponent implements OnInit {

  constructor(
    private ExpertCalibration_Service:ExpertCalibrationService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService,
    private Person_Service:PersonService,
  ) { }

  ngOnInit() {

    this.AddNewExpertCalibration=new FormGroup({
      id :new FormControl(),
      Area_Type:new FormControl(0,Validators.required),
      Response:new FormControl(null,Validators.required),
      Dsc:new FormControl(null),
    })

    this.Nav_Service.CheckValidPage(20).subscribe(
      data=>{
        this.ReadData_Persone()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }


  //#region  Form Add

  AddNewExpertCalibration:FormGroup;

  get_Form_Area_Type(){
    return this.AddNewExpertCalibration.get('Area_Type') as FormControl;
  }

  get_Form_Response(){
    return this.AddNewExpertCalibration.get('Response') as FormControl;
  }

  get_Form_Dsc(){
    return this.AddNewExpertCalibration.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewExpertCalibration(){

    if(Number(this.get_Form_Area_Type().value)==0)
    {
      this.Alertify_Service.ErrorMessage("محل فعالیت را انتخاب کنید")
    }
    else{
      var Record:ExpertCalibration_Interface =Empty_ExpertCalibration_Interface()
      Record.id=0
      Record.area_type=Number(this.get_Form_Area_Type().value)
      Record.response=this.get_Form_Response().value
      Record.dsc=this.get_Form_Dsc().value
      Record.person_id=this.selected_DataList_Persone_Record.id


      this.InProccessing=true
      this.ExpertCalibration_Service.AddExpertCalibration(Record).subscribe(
        data=>{
          this.InProccessing=false
          this.AddNewExpertCalibration.reset()
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.get_Form_Area_Type().setValue("0")
            this.selected_DataList_Persone_Record=Empty_Persone_List_Interface()
            this.ReadData_Persone()

        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )

    }

  }




//#region Person

page:number=0;
Filter_title:String=''

modalRef_Person: any;
ProcssingPersone:boolean=false
openModal_Customer(template: TemplateRef<any>) {
  this.modalRef_Person = this.modalService.show(template);
}

DataList_Persone:Array<Persone_List_Interface>=[]
selected_DataList_Persone_Record:Persone_List_Interface=Empty_Persone_List_Interface();


selected_DataList_Persone(item){
  this.selected_DataList_Persone_Record=item
  this.modalRef_Person.hide()
}

ReadData_Persone(){
  this.ProcssingPersone=true
  this.Person_Service.GetExpertCalibration().subscribe(
    data=>{
      this.DataList_Persone=data
      this.ProcssingPersone=false
    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

Change_Filter_title(){
  this.page=0
}

//#endregion




}
